import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import cs from 'classnames';
import Styles from '../../../Styles.module.scss';

export default function Version() {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={Styles.CommandCard}>
            <div className={Styles.CommandHeader} onClick={() => setExpanded(!expanded)}>
                <div>
                    <span className={Styles.CommandName}>modelpark version</span>
                    <span className={Styles.CommandSummary}>Print version information</span>
                </div>
                <DownOutlined className={cs(Styles.CommandExpandIcon, { [Styles.expanded]: expanded })} />
            </div>

            {expanded && (
                <div className={Styles.CommandBody}>
                    <p className={Styles.CommandDescription}>
                        Displays the CLI version, git commit hash, and build date.
                    </p>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Example</div>
                        <div className={Styles.CodeBlock}>
                            <code>modelpark version</code>
                        </div>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Output</div>
                        <div className={Styles.CodeBlock}>
                            <code>{`modelpark v2.0.0
  commit:  abc1234
  built:   2024-01-01T00:00:00Z`}</code>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
